import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CrossIcon from "../../../../assets/img/svg/svgComponents/CrossIcon"

// import { ignoreFilterItem } from '../constants';
import { regex } from 'views/pages/manage/common/constant';
import { getFilterCount } from '../../../../views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { initialForm } from './constant';
const FilterForm = ({ closePopup,
    dropdownData,
    globalFilter,
    setGlobalFilter,
    filterCount,
    setFilterCount,
    currPageSize,
    searchHandler,
    currentPage
}) => {

    const [filterForm, setFilterForm] = useState(initialForm);
    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value }));
    };

    useEffect(
        () => {
            setFilterForm({
                ...globalFilter,
            })
        },
        [globalFilter]
    );

    const handleApplyFilter = () => {


        searchHandler(0,currPageSize,filterForm)
        let fCount = getFilterCount(filterForm, ['status']);
        setFilterCount(fCount);
        closePopup()
    }
    const resetFilterForm = () => {
        setFilterForm(initialForm)
        searchHandler(0, currPageSize, {...globalFilter,...initialForm})
        setFilterCount(0)
    }

    return <>
        <Card className="mb-0 regular-body label-color"
            style={{ width: "500px", borderRadius: "12px" }}>
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                    <span onClick={closePopup} className='cursor semi-bolder'><CrossIcon /></span>
                </div>

                <div className="d-flex flex-column gap-md">
                    <Row>
                        <Col md={6}>
                            <AAutoComplete
                                label="BU"
                                currentValue={filterForm?.businessAreaValue}
                                items={dropdownData?.bu}
                                handleChange={(value) => {
                                    filterFormHandler("businessAreaValue", value);
                                }}
                                selectAllMenuButton={true}
                                isShowCount={true}
                                isMulti={true}
                            />
                        </Col>
                        <Col md={6}>
                            <AAutoComplete
                                label="Regular Course ID"
                                currentValue={filterForm?.regularCourseId}
                                items={dropdownData?.regularCourseId}
                                handleChange={(value) => {
                                    filterFormHandler("regularCourseId", value);
                                }}
                                selectAllMenuButton={true}
                                isShowCount={true}
                                isMulti={true}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <AAutoComplete
                                label="SD Course ID"
                                currentValue={filterForm?.sdCourseId}
                                items={dropdownData?.sdCourseId}
                                handleChange={(value) => {
                                    filterFormHandler("sdCourseId", value);
                                }}
                                selectAllMenuButton={true}
                                isShowCount={true}
                                isMulti={true}
                            />
                        </Col>
                        <Col md={6}>
                            {/* <AAutoComplete
                label="Region*"
                currentValue={filterForm?.region}
                items={dropdownData?.allRegion}
                handleChange={(value) => {
                  filterFormHandler("region", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              /> */}
                            <AAutoComplete
                                label="Regular term"
                                currentValue={filterForm?.termValue}
                                items={dropdownData?.regTerm}
                                handleChange={(value) => {
                                    filterFormHandler("termValue", value);
                                }}
                                selectAllMenuButton={true}
                                isShowCount={true}
                                isMulti={true}
                            />
                        </Col>
                    </Row>


                    <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                        <AButton
                            variant="primary_filled"
                            className="button_remove_left_margin"
                            onClick={() => {
                                handleApplyFilter();
                            }}
                            disabled={!getFilterCount({ ...filterForm })}
                        >
                            Apply
                        </AButton>

                        {filterCount > 0 && (
                            <AButton
                                variant="danger_filled"
                                className="button_remove_left_margin"
                                // updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                                onClick={resetFilterForm}
                            >
                                Reset
                            </AButton>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    </>
}
export default FilterForm;
